import { useEffect, useState } from "react";
import { listRestores, type RestoreRow } from "../api";

export function Restores() {
  const [rows, setRows] = useState<RestoreRow[] | null>(null);
  const [tenant, setTenant] = useState("");
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => { void reload(); }, [tenant]);
  async function reload() {
    setErr(null);
    try {
      const r = await listRestores({ tenant_id: tenant, limit: "200" });
      setRows(r.restores);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "load failed");
    }
  }

  return (
    <>
      <div className="row spaced">
        <h2>Restore requests</h2>
        <input className="input" placeholder="Tenant ID" value={tenant} onChange={e => setTenant(e.target.value)} style={{ width: 220 }} />
      </div>
      {err && <div className="err">{err}</div>}
      {!rows ? <div>Loading…</div> : (
        <table>
          <thead>
            <tr>
              <th>#</th><th>File</th><th>Path</th><th>By</th><th>Source</th><th>Status</th><th>Requested</th><th>Completed</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td>{r.id}</td>
                <td>{r.filename}</td>
                <td className="mono">{r.original_path}</td>
                <td>{r.requested_by_email ?? "—"}</td>
                <td>{r.source}</td>
                <td>
                  <span className={"badge " + statusClass(r.status)}>{r.status}</span>
                </td>
                <td className="mono">{shortTs(r.requested_at)}</td>
                <td className="mono">{r.completed_at ? shortTs(r.completed_at) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}

function statusClass(s: string): string {
  if (s === "completed") return "green";
  if (s === "streaming") return "amber";
  if (s === "thawing") return "purple";
  if (s === "failed") return "red";
  return "grey";
}
function shortTs(s: string): string { return s.replace("T", " ").replace("Z", "").slice(0, 19); }
